export { StyledModal, StyledPointsModal, StyledDescriptionModal, StyledPeopleModal, StyledNonScrollableModal, StyledTallModal } from "./StyledModal";
